import { Navigate, Outlet } from "react-router-dom";
import { pageRoutes } from "./pageRoutes";

const PrivateRoutes = () =>{

    // Auth logic goes here
    
    let token = localStorage.getItem('token')

    return (
        token?.length ? <Outlet/> : <Navigate to={pageRoutes.dashboard} />
    )
}

export default PrivateRoutes